import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as SearchIcon } from "assets/images/common/svgs/search.svg";
import { ReactComponent as EyeIcon } from "assets/images/common/svgs/eyeIconTable.svg";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useCommunities from "../useHook";
import { useSelector } from "react-redux";
import { useDebounce } from "hooks/useDebounce";
import { UserFiltersDTO } from "utils/helpers/models/common/user-filters.dto";
import DataNotFound from "components/particles/table/data-not-found";
import Pagination from "components/particles/table/pagination";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import useStore from "hooks/useStore";
import { sitePermissions } from "utils/helpers/enums/permissions.enum";

const CommunitiesListing: React.FC = () => {
  const { hasPermission } = useStore();
  const columns: string[] = [
    "Profile",
    "Community/Event Name",
    "Created On",
    // "Status",
    "Action",
  ];

  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const { getCommunities } = useCommunities();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [filters, setFilters] = useState<UserFiltersDTO>(new UserFiltersDTO());
  const [totalElements, setTotalElements] = useState<number>(0);

  const debounceSearch = useDebounce(filters.searchTitle, 1500);

  const handleDelete = async (id: number) => {
    const result = await confirmationPopup();
    if (result.isConfirmed) {
      // const queryParams = {
      //   page: 1,
      //   search
      // }
      // deleteOrganization(id, setData, queryParams, setFilters);
    }
  };

  const buildUpdatedFilters = (
    updates: Partial<UserFiltersDTO> = {},
    resetPage: boolean = false
  ) => {
    const updatedFilters = { ...filters, ...updates };
    if (resetPage) {
      updatedFilters.page = 1;
    }
    return updatedFilters;
  };

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = buildUpdatedFilters(
      { size: limit, limit, page: page + 1 },
      false
    );
    setFilters(updatedFilters);
    getAllCommunities(updatedFilters);
  };

  const getAllCommunities = (filters: UserFiltersDTO) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
        filtersToSend[key] = filters[key];
      }
    }
    const queryParams = {
      ...filtersToSend,
      size: filters.limit,
      page: filters.page - 1,
      searchTitle: filters.searchTitle || "",
    };
    getCommunities(setData, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    getAllCommunities(filters);
  }, [debounceSearch]);

  const handleChangeFilter = (event: any) => {
    const {
      target: { name, value },
    } = event;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    const updatedFilters = buildUpdatedFilters(
      { [name]: trimmedValue as any },
      true
    );
    setFilters(updatedFilters);
    if (name === "searchTitle" && trimmedValue === "") {
      getAllCommunities(updatedFilters);
    }
  };

  const handleSearch = (event: any) => {
    const { key } = event;
    if (key === "Enter") {
      const updatedFilters = buildUpdatedFilters({}, true);
      setFilters(updatedFilters);
      getAllCommunities(updatedFilters);
    }
  };

  const goToDetail = (eventId: number) => {
    navigate(`${siteRoutes.communitiesView}?id=${eventId}`);
  };

  return (
    <div className="">
      <h1 className="tex-2xl sm:text-[32px] text-primaryText font-bold">
        Communities
      </h1>
      <div className="flex justify-end ">
        <div className="w-full sm:w-[388px] relative my-6 flex justify-end">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-primaryText text-lg" />
          <input
            type="search"
            value={filters.searchTitle}
            onChange={handleChangeFilter}
            onKeyUp={handleSearch}
            name="searchTitle"
            placeholder="Search by Community/Event Name"
            className="w-full search-input pl-10 p-2 border-[0.6px] border-borderLightGray rounded-full focus:outline-none bg-coolLightGrayBg"
          />
        </div>
      </div>

      <div>
        <div className="bg-white rounded-t-lg  border border-mediumGrayBorder overflow-x-auto">
          <table className="min-w-full divide-y divide-mediumGrayBorder">
            {/* Table Header */}
            <thead className="bg-white">
              <tr className="text-left">
                {columns.map((column, index) => {
                  return (
                    <th
                      className="px-4 py-4  text-sm font-bold text-left text-primaryText whitespace-nowrap"
                      key={index}
                    >
                      {column}
                    </th>
                  );
                })}
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className="bg-white divide-y divide-mediumGrayBorder">
              {data.map((data, index) => (
                <tr key={index} className="hover:bg-gray-50 ">
                  <td className="px-4 py-4">
                    <img
                      className="rounded-full w-9 h-9 object-cover"
                      src={
                        data?.eventData?.eventPics[0]
                          ? concatPathWithBackendUrl(
                              data?.eventData?.eventPics[0]
                            )
                          : editProfilePicUser
                      }
                      alt={data.Profile}
                    />
                  </td>
                  <td className="px-4 py-4 text-sm max-w-[250px]  text-primaryText font-semibold">
                    {data?.eventData?.title}
                  </td>

                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {data?.startDateTime?.[0]
                      ? new Date(data.startDateTime[0]).toLocaleTimeString(
                          "en-US",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          }
                        )
                      : "-"}
                  </td>
                  <td className="px-4 py-4 text-left whitespace-nowrap w-[124px]">
                    <div className="flex justify-start gap-2 ">
                      {hasPermission(sitePermissions.communitiesRead) ? (
                        <button
                          onClick={() => goToDetail(data?.eventData?.eventId)}
                          className=""
                        >
                          <EyeIcon />
                        </button>
                      ) : (
                        <button className="cursor-not-allowed">
                          <EyeIcon />
                        </button>
                      )}

                      {/* Action Buttons */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Fragment>
          <DataNotFound show={!isLoading && !data.length} />
          {totalElements > 0 && (
            <Pagination
              count={totalElements}
              page={filters.page}
              limit={filters.limit}
              onPageChange={onPageChange}
            />
          )}
        </Fragment>
      </div>
    </div>
  );
};

export default CommunitiesListing;
